(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/_base/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/_base/pay.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class PayBase extends svs.tur.payment.base.Pay {
  constructor(_ref) {
    let wagerModel = _ref.wagerModel,
      apiCallerFunction = _ref.apiCallerFunction;
    if (!(wagerModel || wagerModel instanceof Backbone.Model)) {
      svs.tur.payment.logger.warn('wagerModel is required. Aborting.');
      throw Error('Missing argument wagerModel');
    }
    super();
    this.wagerModel = wagerModel;
    this.apiCallerFunction = apiCallerFunction;
  }
  onAccountStatusSuccess() {
    this.showConfirmDialog();
  }
  onAccountStatusFailed() {
    this.destroy();
  }
  getConfirmDialogProps() {
    return {
      productName: this.productName,
      price: this.price,
      accountBalance: this.account.balance
    };
  }
  sendPayment() {
    if (this.paymentCallInProgress) {
      svs.tur.payment.logger.info('Jupiter call already in progress, blocking');
      return;
    }
    this.jupiterCaller = new svs.tur.payment.api.jupiter.Jupiter({
      data: this.payableObj,
      apiCallerFunction: this.apiCallerFunction,
      onSuccess: _ref2 => {
        let response = _ref2.response;
        return this.onPaymentSuccess({
          response
        });
      },
      onError: (xhr, textStatus, errorThrown) => this.onPaymentError({
        xhr,
        textStatus,
        errorThrown
      })
    });
    this.jupiterCaller.call();
    this.paymentCallInProgress = true;
  }
  onPaymentSuccess(_ref3) {
    let response = _ref3.response;
    const PAYMENT_SUCCESS = svs.tur.payment.constants.events.PAYMENT_SUCCESS;
    let paymentFailed = false;
    const handleMultiWagersError = tpError => {
      paymentFailed = true;
      const facility = tpError.facility,
        errCode = tpError.errCode,
        details = tpError.details,
        errDesc = tpError.errDesc;
      const code = "".concat(facility, " ").concat(errCode);
      this.onPaymentError({
        xhr: {
          responseText: JSON.stringify({
            error: {
              code,
              message: errDesc
            }
          })
        },
        textStatus: details,
        errorThrown: errDesc
      });
    };
    if (this.jupiterCaller.isOwnRows(this.payableObj)) {
      if (Array.isArray(response.regWagerResults)) {
        const failedWager = response.regWagerResults.find(wagerResponse => Boolean(wagerResponse.tpError));
        if (failedWager) {
          handleMultiWagersError(failedWager.tpError);
        }
      }
    } else if (this.isMultiplePayableObjs()) {
      response.regWagerResults.forEach((wagerResponse, index) => {
        if (wagerResponse.tpError) {
          handleMultiWagersError(wagerResponse.tpError);
        } else if (wagerResponse.regWagerResult) {
          this.sendAnalytics({
            wagerId: this.getWagerIdFromApiResponse(wagerResponse.regWagerResult),
            betsObj: this.payableObj[index].bets
          });
        }
      });
    } else {
      this.sendAnalytics(_objectSpread({
        wagerId: this.getWagerIdFromApiResponse(response),
        betsObj: this.payableObj.bets
      }, response));
    }
    if (!paymentFailed) {
      svs.tur.payment.logger.debug(PAYMENT_SUCCESS);
      this.trigger(PAYMENT_SUCCESS, response);
      this.showSuccessDialog();
    }
  }
  onPaymentError(_ref4) {
    let xhr = _ref4.xhr,
      textStatus = _ref4.textStatus,
      errorThrown = _ref4.errorThrown;
    svs.tur.payment.logger.warn("failure (".concat(JSON.stringify(xhr), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));
    this.paymentErrorHandler = new svs.tur.payment.services.PaymentError({
      xhr
    });
    const PAYMENT_ERROR = svs.tur.payment.constants.events.PAYMENT_ERROR;
    const _this$paymentErrorHan = this.paymentErrorHandler.getErrorData(),
      errorType = _this$paymentErrorHan.errorType;
    const detailedEvent = "".concat(PAYMENT_ERROR, ":").concat(errorType);
    this.trigger(PAYMENT_ERROR, {
      errorType
    });
    this.trigger(detailedEvent, {
      xhr
    });

    if (Object.keys(this.callbacks).indexOf(detailedEvent) === -1) {
      this.paymentErrorHandler.showErrorDialog();
    } else {
      svs.tur.payment.logger.info("Custom listener found for \"".concat(detailedEvent, "\". Preventing default!"));
    }
    this.destroy();
  }
  showSuccessDialog() {
    new svs.tur.payment.dialogs.PaymentSuccess({
      onConfirm: () => {
        this.onSuccessDialogConfirm();
      }
    });
  }
  onSuccessDialogConfirm() {
    const DIALOG_SUCCESS_CONFIRM = svs.tur.payment.constants.events.DIALOG_SUCCESS_CONFIRM;
    svs.tur.payment.logger.debug(DIALOG_SUCCESS_CONFIRM);
    this.trigger(DIALOG_SUCCESS_CONFIRM, {});
    this.destroy();
  }
  onErrorDialogConfirm() {
    const DIALOG_ERROR_CONFIRM = svs.tur.payment.constants.events.DIALOG_ERROR_CONFIRM;
    svs.tur.payment.logger.debug(DIALOG_ERROR_CONFIRM);
    this.trigger(DIALOG_ERROR_CONFIRM, {});
    this.destroy();
  }

  sendAnalytics(_ref5) {
    let wagerId = _ref5.wagerId,
      betsObj = _ref5.betsObj;
    new svs.tur.payment.services.Analytics({
      betsObj,
      wagerId,
      wagerModel: this.wagerModel
    });
  }
  isMultiplePayableObjs() {
    return Array.isArray(this.payableObj);
  }
  getWagerIdFromApiResponse(response) {
    return response.wagerClientSerial;
  }
}
svs.tur.payment.api.jupiter.base.PayBase = PayBase;

 })(window);